import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqVendorProjection } from "../sanity/vendor.projection"

export const queryVendors = {
  async vendors(parent, args, context, info) {
    let { offset, limit, sort, lang = AppSettings.defaultLocale(), cdn = true, sortWithinLimits } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.VENDORS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    let vendors
    vendors = await client.fetch(
      groq`{
        "total":count(*[_type=="vendor"]),
        "items":*[_type=="vendor"  ${draftsFilter}]${pipesAndLimits} {
          ${groqVendorProjection()}
        }
      }`,
    )

    if (!vendors?.items)
      vendors = {
        offset,
        limit,
        count: 0,
        total: 0,
        items: [],
      }

    vendors = {
      ...vendors,
      offset,
      limit,
      count: vendors.items.length,
    }

    return vendors
  },
}
